/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse } from '../../types/TelegramGeoControllerGetRegionsWithoutCountryId.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetRegionsWithoutCountryId } from '../../methods/telegramGeoGetRegionsWithoutCountryId.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetRegionsWithoutCountryIdQueryKey = () => [{ url: '/api/telegram/geo/regions' }] as const;

export type TelegramGeoGetRegionsWithoutCountryIdQueryKey = ReturnType<
  typeof telegramGeoGetRegionsWithoutCountryIdQueryKey
>;

export function telegramGeoGetRegionsWithoutCountryIdQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetRegionsWithoutCountryIdQueryKey();
  return queryOptions<
    TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetRegionsWithoutCountryId(config);
    },
  });
}

/**
 * {@link /api/telegram/geo/regions}
 */
export function useTelegramGeoGetRegionsWithoutCountryId<
  TData = TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse,
  TQueryData = TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetRegionsWithoutCountryIdQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetRegionsWithoutCountryIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetRegionsWithoutCountryIdQueryKey();

  const query = useQuery(
    {
      ...telegramGeoGetRegionsWithoutCountryIdQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
